module.exports = __webpack_public_path__ + "static/basker-7bb3a79da475740f733147358b83957b.png";